"use strict";

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = exports.TinyLoader = void 0;

var react_1 = __importDefault(require("react"));

var react_router_dom_1 = require("react-router-dom");

var loader_1 = __importDefault(require("../loader"));

var Button_1 = __importDefault(require("@material-ui/core/Button"));

exports.TinyLoader = function () {
  return react_1.default.createElement("span", {
    style: {
      display: 'inline-block'
    }
  }, react_1.default.createElement(loader_1.default, {
    size: 20
  }));
};

exports.Label = function (props) {
  var isLoading = props.isLoading,
      label = props.label;

  if (!isLoading) {
    return react_1.default.createElement(react_1.default.Fragment, null, label);
  }

  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(exports.TinyLoader, null), " \xA0\xA0", label, ' ');
};

var MyButton = function MyButton(props) {
  var label = props.label,
      target = props.target,
      onClick = props.onClick,
      _props$primary = props.primary,
      primary = _props$primary === void 0 ? false : _props$primary,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      type = props.type,
      style = props.style;
  var color = props.color || primary ? 'primary' : 'default';
  var disabledFinal = loading || disabled;

  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      redirect = _react_1$default$useS2[0],
      setRedirect = _react_1$default$useS2[1];

  var handleClick = function handleClick() {
    if (onClick) {
      return onClick();
    }

    setRedirect(true);
  };

  if (redirect && target) {
    return react_1.default.createElement(react_router_dom_1.Redirect, {
      to: target
    });
  }

  return react_1.default.createElement(Button_1.default, {
    variant: "contained",
    color: color,
    disabled: disabledFinal,
    onClick: handleClick,
    type: type,
    style: style
  }, react_1.default.createElement(exports.Label, {
    label: label,
    isLoading: loading
  }));
};

exports.default = MyButton;